"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountClosureReason = void 0;
var AccountClosureReason;
(function (AccountClosureReason) {
    AccountClosureReason["LOWER_MONTHLY_PAYMENTS"] = "lower_monthly_payment";
    AccountClosureReason["LOWER_APR"] = "lower_apr";
    AccountClosureReason["ACCESS_MORE_HOME_EQUITY"] = "access_more_home_equity";
    AccountClosureReason["SELLING_HOME"] = "selling_home";
    AccountClosureReason["NOT_HAPPY"] = "not_happy";
    AccountClosureReason["NO_REASON_STATED"] = "no_reason_stated";
    AccountClosureReason["LINE_SIZE_TOO_LOW"] = "line_size_too_low";
    AccountClosureReason["NOT_USE"] = "not_use";
    AccountClosureReason["HIGHER_INCOME"] = "higher_income";
    AccountClosureReason["OTHER"] = "other";
    AccountClosureReason["GETTING_ANOTHER_HELOC"] = "getting_another_heloc";
    AccountClosureReason["MORTGAGE_REFI"] = "mortgage_refi";
    AccountClosureReason["REFI_OR_HOUSE_SOLD"] = "refi_or_house_sold";
    AccountClosureReason["DEPRECATED_REFI"] = "refi";
    AccountClosureReason["DEPRECATED_CASH_OUT_REFI"] = "cash_out_refi";
    // for account being detected as fraud, we still need to go through the regular account closure procedure (eg reconveyance, etc)
    AccountClosureReason["FRAUD"] = "fraud";
    // account is being closed by aven because contingency was not cleared
    AccountClosureReason["CONTINGENCY_REJECTED"] = "contingency_rejected";
    // account is being closed via ops endpoint LoanApplicationStatus override
    AccountClosureReason["OPS_STATUS_OVERRIDE"] = "ops_status_override";
    // account is being closed via ops endpoint due to underwriting denial
    AccountClosureReason["OPS_UNDERWRITING_DENIAL"] = "ops_underwriting_denial";
    // account is being closed through the employee account closure ops endpoint
    AccountClosureReason["CLOSING_EMPLOYEE_ACCOUNT"] = "closing_employee_account";
    // UCC-specific reasons
    AccountClosureReason["REWARDS_REQUIREMENT_IS_TOO_STRICT"] = "rewards_requirement_is_too_strict";
    AccountClosureReason["REWARDS_AMOUNT_IS_TOO_LOW"] = "rewards_amount_is_too_low";
    AccountClosureReason["UCC_REWARDS_CARD_OFFER_DECLINED_PRE_ACTIVATION"] = "ucc_rewards_card_offer_declined_pre_activation";
    // Crypto-specific reasons
    AccountClosureReason["WITHDRAW_ALL_BITCOIN"] = "withdraw_all_bitcoin";
})(AccountClosureReason || (exports.AccountClosureReason = AccountClosureReason = {}));
